<template>
  <div id="app">
    <i v-show="false" style="position: absolute;" class="el-icon-loading"></i>
    <div v-if="!showProject" class="project-loading">
      <van-loading type="circle" size="50"/>
      <!-- 等待页面显示 -->
    </div>
    <template v-else>
      <keep-alive :include="needKeepAlive">
          <router-view />
      </keep-alive>
    </template>
    <templatedetail v-show="$route.path == '/template-detail'"></templatedetail>
    <!-- <router-view  /> -->
    <div v-if="showLoading" class="project-loading">
          <div class="loading-content">
              <img class="icon" src="@/assets/img/loading.png" />
              <div class="text">{{typeof(showLoading) == 'string'? showLoading : 'Waiting'}}...</div>
          </div>
    </div>


    <!-- 推荐去谷歌浏览器 -->
    <div class="recommended" v-if="showRecommended">
      <div class="close" @click="setRecommended(false)"><img src="@/assets/img/close5.png" /></div>
      <div class="icon"><img src="@/assets/img/chrome.png" /></div>
      <div class="text">
        <div>{{$t('text.recommend_chrome')}}</div>
        <div>{{$t('text.not_chrome_use_chrome')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import templatedetail from './components/template.vue';

export default {
  name: 'App',
  components: { templatedetail },
  data() {
    return {
      showProject: false,
      showInvitation: false,
    }
  },
  computed: {
    showLoading() {
      return this.$store.state.loading;
    },
    needKeepAlive() {
      return this.$store.state.needKeepAlive;
    },
    showRecommended() {
      return this.$store.state.showRecommended;
    }
  },
  watch: {
    showProject(val) {
      if(val) {
        // 客服信息
        this.$store.dispatch("common/getCustomerServiceInfo");
        this.$store.dispatch("common/getPosition");
      }
    },

    // 如果有路由传值值太长的话matomo会监听不到并报414，就不能根据router自动注册了：解决办法是在app.vue中监听router，然后设置
    $route(to, from) {
        // 设置页面地址，可使用location.href，注意，如果使用的路由模式是hash模式，需要把url中的#号截取掉
        if(this.$matomo){
          this.$matomo.setCustomUrl(window.location.href);
          this.$matomo.trackPageView(to.meta.title);//设置页面名称
        }
    },
  },
  async beforeCreate() {
    // var googlejs = document.createElement("script");
    // googlejs.setAttribute("type", "text/javascript");
    // googlejs.setAttribute("src", "https://accounts.google.com/gsi/client");
    // document.body.insertBefore(googlejs, document.body.lastChild);
    //
    // var facebookjs = document.createElement("script");
    // facebookjs.setAttribute("type", "text/javascript");
    // facebookjs.setAttribute("src", "https://connect.facebook.net/zh_CN/sdk.js#xfbml=1&version=v3.3&appId=772231301527151&autoLogAppEvents=1");
    // document.body.insertBefore(facebookjs, document.body.lastChild);

    // 获取数据中心前进行定位
    // try {
    //   let GeolocationCoordinates = await this.$utils.getPositionLa();
    //   if(GeolocationCoordinates.latitude) {
    //     this.$store.commit("common/savePosition", {
    //       latitude: GeolocationCoordinates.latitude,
    //       longitude: GeolocationCoordinates.longitude
    //     })
    //   }
    // } catch (error) {
    //
    // }
    // 获取数据中心
    this.$store.dispatch("common/requestDataconter").then(list => {
      // let id = list.length? (list[0].tenantId || null) : null;

      const { client_user_id, user_id, token, reg_platform_type } = this.$route.query;
      if(user_id) this.$store.commit("user/saveUserId", user_id);
      if(client_user_id) this.$store.commit("user/saveClientUserId", client_user_id);
      if(reg_platform_type) this.$store.commit("common/saveRegPlatformType", reg_platform_type);


      // 判断是否登录
      if(!this.$store.getters.isLogin && !token) {
        this.$store.dispatch("user/getClientGuestToken",
        {}
        // {datacenter_uuid:id,user_id,client_user_id}
      ).then(() => {
          this.showProject = true;
        });
      }else {
        if(token && !this.$store.getters.isLogin) {
          this.$store.commit("user/changeUserinfo", {...this.$store.state.user.userinfo, access_user_token: token});
        }
        this.showProject = true;
        this.$apis.user.getUserInfo().then(res => {
            this.$store.commit("user/changeUserinfo", {...this.$store.state.user.userinfo, ...res.data});
        })
      }
    });
    // 获取电话区号
    this.$store.dispatch("common/getPhoneCode");

    // 国家列表
    this.$store.dispatch("common/getLocationList");
  },

  mounted() {
    if(this.showRecommended === true) {
      let showRecommended = true;
      var explorer = window.navigator.userAgent;
      if (explorer.indexOf("QQBrowser")>=0 || explorer.indexOf("QQ")>=0) {
        showRecommended = true;
      } else if(explorer.indexOf("Chrome")>=0) {
        showRecommended = false;
      }
      this.setRecommended(showRecommended);
    }

    window.addEventListener("popstate", e => {
      try{
      let routerHistory = this.$store.state.routerHistory;
      let length = routerHistory.length;
      length = length - 2;
      routerHistory.length = length;
      this.$store.commit("addRouterHistory", routerHistory)
      }catch(err) {
        console.log(err)
      }
    })
    // 禁止右键菜单
    document.addEventListener("contextmenu", e => e.preventDefault());
  },

  methods: {
    setRecommended(payload) {
      this.$store.commit("showRecommended", payload)
    }
  }
}
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  // position: fixed;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
}

.project-loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .loading-content {
        width: 172px;
        height: 112px;
        border-radius: 8px;
        background-color: rgba(0, 0, 0, 0.8);

        .icon {
            width: 40px;
            height: 40px;
            margin-top: 24px;
            animation:fadenum 1s linear infinite;
        }

        .text {
            color: white;
            font-size: 14px;
            line-height: 16px;
            margin-top: 6px;
        }
    }
}


.recommended {
  position: fixed;
  height: 100px;
  bottom: 52px;
  display: flex;
  z-index: 999;
  width: 100%;
  background: rgba(0, 0, 0, 0.60);

  .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
  }

  .icon {
    width: 40px;
    height: 40px;
    margin-top: 30px;
    margin-left: 16px;
    margin-right: 12px;
  }

  .text {
    flex: 1;
    text-align: left;

    div:first-child {
      width: 283px;
      height: 40px;
      font-size: 17px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 20px;
      margin: 12px 0 4px;
    }

    div:last-child {
      width: 293px;
      height: 32px;
      font-size: 12px;
      font-weight: 400;
      color: #D8DBDF;
      line-height: 16px;
    }
  }
}

@keyframes fadenum{
    100% {transform:rotate(360deg);}
}
</style>



// WEBPACK FOOTER //
// src/App.vue